import { render } from "./UDPEdit.vue?vue&type=template&id=35dc9786&ts=true"
import script from "./UDPEdit.vue?vue&type=script&lang=ts"
export * from "./UDPEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__